/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_kleber__village__description = /** @type {(inputs: {}) => string} */ () => {
	return `empfehlen dieses Zwischenstopp Dorf für Familien`
};

const en_kleber__village__description = /** @type {(inputs: {}) => string} */ () => {
	return `recommend this stopover village for families`
};

const es_kleber__village__description = /** @type {(inputs: {}) => string} */ () => {
	return `Recomiendo este pueblo de parada obligatoria para familias.`
};

const fr_kleber__village__description = /** @type {(inputs: {}) => string} */ () => {
	return `recommande ce village étape pour les familles`
};

const it_kleber__village__description = /** @type {(inputs: {}) => string} */ () => {
	return `consiglio questo villaggio di sosta per le famiglie`
};

const nl_kleber__village__description = /** @type {(inputs: {}) => string} */ () => {
	return `raad dit tussenstopdorp aan voor gezinnen`
};

const pt_kleber__village__description = /** @type {(inputs: {}) => string} */ () => {
	return `recomendo esta vila de parada para famílias`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const kleber__village__description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.kleber__village__description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("kleber__village__description", locale)
	if (locale === "de") return de_kleber__village__description(inputs)
	if (locale === "en") return en_kleber__village__description(inputs)
	if (locale === "es") return es_kleber__village__description(inputs)
	if (locale === "fr") return fr_kleber__village__description(inputs)
	if (locale === "it") return it_kleber__village__description(inputs)
	if (locale === "nl") return nl_kleber__village__description(inputs)
	return pt_kleber__village__description(inputs)
};